import { useId } from 'react';

interface ShopAwningProps {
  /** Decorative awning height in pixels. */
  height?: number;
  /** Extra classes merged onto the wrapper. */
  className?: string;
}

const VIEWBOX_WIDTH = 1440;
const VIEWBOX_HEIGHT = 72;
const SCALLOP_WIDTH = 160;
const SCALLOP_TOP = 28;
const SCALLOP_RADIUS_Y = 34;
const TOP_CORNER_RADIUS = 18;
const CHOCOLATE = '#4A2B18';

const buildScallopPath = () => {
  const commands = [
    `M${TOP_CORNER_RADIUS},0`,
    `H${VIEWBOX_WIDTH - TOP_CORNER_RADIUS}`,
    `Q${VIEWBOX_WIDTH},0 ${VIEWBOX_WIDTH},${TOP_CORNER_RADIUS}`,
    `V${SCALLOP_TOP}`,
  ];

  for (let x = VIEWBOX_WIDTH; x > 0; x -= SCALLOP_WIDTH) {
    commands.push(
      `A${SCALLOP_WIDTH / 2},${SCALLOP_RADIUS_Y} 0 0 1 ${x - SCALLOP_WIDTH},${SCALLOP_TOP}`,
    );
  }

  commands.push(
    `V${TOP_CORNER_RADIUS}`,
    `Q0,0 ${TOP_CORNER_RADIUS},0`,
    'Z',
  );
  return commands.join(' ');
};

const SCALLOP_PATH = buildScallopPath();

export function ShopAwning({ height = 46, className = '' }: ShopAwningProps = {}) {
  const uid = useId().replace(/:/g, '');
  const clipId = `shop-awning-clip-${uid}`;
  const bevelId = `shop-awning-bevel-${uid}`;
  const shadowId = `shop-awning-shadow-${uid}`;

  return (
    <div
      className={`absolute left-0 top-full -mt-[10px] z-0 w-full overflow-visible leading-[0] pointer-events-none ${className}`}
      style={{ height: `${height}px` }}
      aria-hidden="true"
    >
      <svg
        className="block h-full w-full"
        viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
        preserveAspectRatio="none"
      >
        <defs>
          <clipPath id={clipId} clipPathUnits="userSpaceOnUse">
            <path d={SCALLOP_PATH} />
          </clipPath>

          <linearGradient id={bevelId} x1="0" y1="0" x2="0" y2={VIEWBOX_HEIGHT} gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0" />
            <stop offset="18%" stopColor="#FFFFFF" stopOpacity="0" />
            <stop offset="58%" stopColor="#000000" stopOpacity="0" />
            <stop offset="100%" stopColor="#000000" stopOpacity="0.5" />
          </linearGradient>

          <filter id={shadowId} x="-5%" y="-20%" width="110%" height="170%">
            <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="#000000ff" floodOpacity="0.3" />
          </filter>
        </defs>

        <g clipPath={`url(#${clipId})`} filter={`url(#${shadowId})`}>
          <rect width={VIEWBOX_WIDTH} height={VIEWBOX_HEIGHT} fill={CHOCOLATE} />
          <rect width={VIEWBOX_WIDTH} height={VIEWBOX_HEIGHT} fill={`url(#${bevelId})`} />
        </g>

      </svg>
    </div>
  );
}
